import React, { useEffect, useState } from 'react'
import { CuratedMediaList, CuratedMediaListProperties } from 'models';
import * as modelProps from 'models/curatedMediaList/curatedMediaList-property-definitions'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import utils from 'features/curatedMediaList/curatedMediaList-util'
import validations from 'features/curatedMediaList/curatedMediaList-validation'

export interface CuratedMediaListProps {
    BuildList?: (
        page: any,
        name: CuratedMediaListProperties,
        form: CuratedMediaList,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: CuratedMediaList
    onUpdate?: (form: CuratedMediaList, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function CuratedMediaListForm(props: CuratedMediaListProps) {
    let [form, setForm] = useState({} as CuratedMediaList)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as CuratedMediaList)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as CuratedMediaList)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<CuratedMediaList, CuratedMediaListProperties> | any =
    {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.CuratedMediaListProperties.Id,
                modelProps.CuratedMediaListProperties.Deleted,
                modelProps.CuratedMediaListProperties.Version,
                modelProps.CuratedMediaListProperties.Created,
                modelProps.CuratedMediaListProperties.Updated,
                modelProps.CuratedMediaListProperties.Owner,
                modelProps.CuratedMediaListProperties.Active,
                modelProps.CuratedMediaListProperties.ProcessedMedia,
                modelProps.CuratedMediaListProperties.Released,
                modelProps.CuratedMediaListProperties.Media,
            ].includes(x.name))
        },
        BuildList: (
            page,
            name: CuratedMediaListProperties,
            form: CuratedMediaList,
        ) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: CuratedMediaList,
            property: CuratedMediaListProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: CuratedMediaListProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<CuratedMediaList, CuratedMediaListProperties>(args)}
        </React.Fragment>
    )
}
